import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractGroupItem from './abstractGroupItem';
import GroupItem from './groupItem';

namespace('Ofcs.Editor.Item');

/**
 * @class SetGroupItem
 * @extends GroupItem
 */
export default window.Ofcs.Editor.Item.SetGroupItem = GroupItem.extend({

    /**
     * Item type
     *
     * @property {string} type
     */
    type: 'setgroup',

    /**
     * Center point of group at the time the group is selected.
     * Used to rotate around the same center point in several steps.
     *
     * @property {Point} rotationCenter
     */
    rotationCenter: null,

    defaults: {
        /**
         * @property {string} Type
         */
        type: 'SetGroup',

        /**
         * Name of the item
         * @property {string} attributes.name
         */
        name: null,

        /**
         * Current rotation
         * @property {number} attributes.rotation
         */
        rotation: 0,

        /**
         * Extended path coordinates
         * @property {Array} attributes.ext
         */
        ext: [],

        /**
         * Original path coordinates
         * @property {Array} attributes.orig
         */
        orig: [],

        /**
         * Safety margin path coordinates
         * @property {Array} attributes.safety
         */
        safety: [],

        /**
         * Depth that the item sinks into the foam
         * @property {number} attributes.depth
         */
        depth: 0,

        /**
         * Total depth of the item
         * @property {number} attributes.totalDepth
         */
        totalDepth: 0,
    },

    /**
     * Initializes a new group item
     *
     * @constructor
     */
    initialize() {
        AbstractGroupItem.prototype.initialize.call(this);

        this.supportsAlign = true;
        this.supportsVersions = true;
    },

    /**
     * Translate object into json stringable types. This method will be used
     * by JSON.stringify() automaticly.
     *
     * @return {Object}
     */
    toJSON(...args) {
        const json = AbstractGroupItem.prototype.toJSON.apply(this, args);

        json.productId = this.get('productId');

        return json;
    },
});
